import { z } from 'zod';
import {
  TimeValidation,
  ThesisValidation,
  DescriptionValidation,
  RoundValidation,
} from 'shared/validation/validationTemplates';

export const CreateDebateFormValidation = TimeValidation.and(ThesisValidation)
  .and(DescriptionValidation)
  .and(RoundValidation);

export type TCreateDebateFormType = z.infer<typeof CreateDebateFormValidation>;
